import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "More Scoping",
description: "Extend Freon’s scoping system by introducing namespace additions. Learn how to define the Test model unit and restrict visible question names within each Step to those belonging to the referenced Page.",
tags: [ "Freon", "scoping", "namespaces", "namespace addition", "Step", "Page", "Test", "Scenario", "Answer", "Flow", "questions", "DSL", "Education language", "tutorial"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};